// helper function to determine whether a product is pre-sale or not
export const isPreSale = (product) => {
  // check for the metafield "Pre-Sale Name"
  if (
    product?.metafields?.find(
      (metafield) =>
        metafield?.namespace === "custom" && metafield?.key === "pre_sale_name"
    )
  ) {
    // then check that the inventory is less than or equal to zero
    if (product?.totalInventory <= 0) {
      // then check that at least one variant is available for sale
      if (product?.variants.some((variant) => variant.availableForSale)) {
        return true;
      }
    }
  }

  return false;
};
